import { fontWeight } from '@devrangex/rui'
import { css } from '@emotion/react'
import dayjs from 'dayjs'
import { useMemo } from 'react'

import logo from '../assets/logo-new.svg'
import RankTable from '../components/rank/RankTable'
import { useFetchCompetition } from '../components/rank/useFetchRank'


const pageContainer = css({
  backgroundColor: '#16181B',
  minHeight: '100vh',
  paddingTop: '6vh',

  '@media screen and (orientation: portrait)': {
    paddingTop: '4vh',
  },
})

const rankPageStyle = css`
  max-width: 1720px;
  margin-inline: auto;
  height: auto;
`

const headerStyle = css`
  position: relative;
  width: calc(100% - 8vw);
  margin: 0 4vw 3vh 4vw;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & img {
    width: 5vw;
    margin-bottom: 16px;
  }

  & h1 {
    font-size: 2vw;
    font-weight: ${fontWeight.semibold};
    word-break: keep-all;
    margin-bottom: 8px;
  }

  & h3 {
    font-size: 1vw;
    font-weight: ${fontWeight.regular};
    color: #8e9298;
  }

  @media screen and (orientation: portrait) {
    & img {
      width: 5vh;
    }

    & h1 {
      font-size: 2vh;
    }

    & h3 {
      font-size: 1vh;
    }
  }
`

const trialCss = css`
  padding: 0.6vw 1vw;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #c42942;
  background: #1b1e22;
  box-shadow: 0px 4px 30px 0px rgba(154, 38, 58, 0.15);
  font-size: 1vw;
  color: #8e9298;

  & strong {
    font-size: 2vw;
    font-weight: bold;
    color: transparent;
    background: linear-gradient(
      90deg,
      rgba(240, 36, 59, 1) 0%,
      rgba(255, 104, 231, 1) 100%
    );
    background-clip: text;
  }

  @media screen and (orientation: portrait) {
    font-size: 1.2vh;
    padding: 0.4vh 1vh;

    & strong {
      font-size: 2.5vh;
      font-weight: bold;
      color: transparent;
      background: linear-gradient(
        90deg,
        rgba(240, 36, 59, 1) 0%,
        rgba(255, 104, 231, 1) 100%
      );
      background-clip: text;
    }
  }
`

const mainStyle = css`
  width: calc(100% - 8vw);
  min-height: 60vh;
  margin: 0 4vw;
`

const footerStyle = css`
  background-color: #0d0f11;
  width: 100%;
  height: 7.5vh;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #696e76;
  font-size: 1vw;

  @media screen and (orientation: portrait) {
    font-size: 1vh;
    height: 6vh;
  }
`

export default function RankPage() {
  const { data: competition, totalTrial } = useFetchCompetition()

  const competitonDate = useMemo(() => {
    if (!competition) return '-'

    const toYMD = (date: string) => {
      return dayjs(date).format('YYYY년 M월 D일')
    }

    return `${toYMD(competition.startDate)} ~ ${toYMD(competition.endDate)}`
  }, [competition])

  return (
    <div css={pageContainer}>
      <div css={rankPageStyle}>
        <header css={headerStyle}>
          {competition && (
            <div>
              <img src={logo} alt='logo' />
              <h1>{competition.title}</h1>
              <h3>{competitonDate}</h3>
            </div>
          )}

          <p css={trialCss}>
            누적 참여 수<br />
            <strong>{totalTrial}</strong>
          </p>
        </header>

        <main css={mainStyle}>
          <RankTable />
        </main>

        <footer css={footerStyle}>
          순위는 1위부터 50위까지 노출됩니다
        </footer>
      </div>
    </div>
  )
}
